export default {

  setIsDebugEnabled(state, target) {
    state.isDebugEnabled = target;
  },
  setLanguageSelectorEnlarged(state, target) {
    state.isLanguageSelectorEnlarged = target;
  },
  setLocale(state, target) {
    state.locale = target;
  },
  reset(state) {
    state.shareOpen = false;
    state.photoOpen = false;
    state.placed = false;
  },
  lockBodyScroll(state, target) {
    if(target){
      window.scrollTo(0, 0);
      document.querySelector('body').style.position = "fixed";
      document.querySelector('body').style.overflow = "hidden";
    } else {
      document.querySelector('body').style.position = "absolute"
      document.querySelector('body').style.overflow = "scroll";
    }
  },

  //-----SCENE CHANGING-----
  setIsNewSceneLoading(state, target) {
    state.isNewSceneLoading = target;
  },

  //-----SCREEN DIMENSIONS-----
  setTrueVW(state, target) {
    state.trueVW = target;
  },
  setTrueVH(state, target) {
    state.trueVH = target;
  },
};
